const getColorValueFromHexColor = (value: string) => {
  return value.slice(0, 7);
};

export default getColorValueFromHexColor;
